export default {
    /**
     * Creates the request object and it's metadata for WMS GetFeatureInfo.
     * @param {object} layer
     * @param {object} options
     * @param {string} infoFormat
     * @param {string} viewer
     * @return {object} an object with `request`, containing request paarams, `metadata` with some info about the layer and the request, and `url` to send the request to.
     */
    buildRequest: (layer, { coordinate, resolution, projection, currentLocale, params: defaultParams, maxItems = 10, tolerance = 0 } = {}, infoFormat, viewer, featureInfo) => {

    }
};